import { useAppSelector } from 'hooks/redux';
import React, { useEffect, useState } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { api } from 'api/root';
import './footer.scss'

interface WhoAmIResponse {
    name: string;
    message: string;
    timestamp: string;
    featureEnabled: boolean;
}

export default function Footer() {
    const { filteredData } = useAppSelector(state => state.footerSlice);
    const flags = useFlags();
    const [whoAmIData, setWhoAmIData] = useState<WhoAmIResponse | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const whoAmIFlag = flags.whoami;

    console.log('LaunchDarkly flags:', flags);

    useEffect(() => {
        const fetchWhoAmI = async () => {
            if (!whoAmIFlag) {
                // Reset state when flag is disabled
                setWhoAmIData(null);
                setLoading(false);
                setError(null);
                return;
            }
            
            setLoading(true);
            setError(null);
            
            try {
                const response = await api.get<WhoAmIResponse>('/api/whoami');
                setWhoAmIData(response.data);
            } catch (err) {
                console.error('Failed to fetch whoami data:', err);
                setError('Failed to load user information');
            } finally {
                setLoading(false);
            }
        };

        fetchWhoAmI();
    }, [whoAmIFlag]);

    return (
        <footer className='footer'>
            <div className='footerContent'>
                <div title='The number of records in the Subsurface dataset based on the current filters' >
                    <span className='title'>S</span>
                    <span className='value'>{filteredData.storageDataCount}</span>
                </div>
                <div title='The number of records in the CCS Projects dataset based on the current filters' >
                    <span className='title'>CCS</span>
                    <span className='value'>{filteredData.ccsProjectDataCount}</span>
                </div>
                <div title='The number of records in the CO2 Emitters dataset based on the current filters' >
                    <span className='title'>E</span>
                    <span className='value'>{filteredData.sourceDataCount}</span>
                </div>
                <div title='The number of records in the Infrastructure dataset based on the current filters' >
                    <span className='title'>I</span>
                    <span className='value'>{filteredData.transportDataCount}</span>
                </div>
                <div title='The number of records in the Production dataset based on the current filters' >
                    <span className='title'>P</span>
                    <span className='value'>{filteredData.productionDataCount}</span>
                </div>
                <div title='The number of records in the User dataset based on the current filters' >
                    <span className='title'>U</span>
                    <span className='value'>{filteredData.userDataCount}</span>
                </div>
                
                {whoAmIFlag === true && (
                    <div className='whoami-section' title='Current user information'>
                        <span className='title'>Who Am I:</span>
                        {loading && <span className='value'>Loading...</span>}
                        {error && <span className='value error'>{error}</span>}
                        {whoAmIData && !loading && !error && (
                            <span className='value'>
                                {whoAmIData.name} ({new Date(whoAmIData.timestamp).toLocaleTimeString()})
                            </span>
                        )}
                    </div>
                )}
            </div>
        </footer>
    )
}